import { render } from "./CollecteConfig.vue?vue&type=template&id=c3f7e460&scoped=true"
import script from "./CollecteConfig.vue?vue&type=script&lang=js"
export * from "./CollecteConfig.vue?vue&type=script&lang=js"

import "./CollecteConfig.vue?vue&type=style&index=0&id=c3f7e460&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3f7e460"]])

export default __exports__